export default __webpack_public_path__ + "locales/ro/PDFFormDialog.json?hash=fc218e4470e118dd51abaa79e95a40f9";